<template>
  <v-container fluid style="position: relative;">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 mt-3 class="box650">
        <v-form v-model="valid" @submit.prevent="userSignInCall({email, password, terms, privacy, couponId})">
          <!-- <v-layout column> -->
            <v-flex xs12 class="text-xs-center fetivales-logo" :class="{[festivales[$route.path].class]:true}" mt-2 v-if="festivales[$route.path] && festivales[$route.path].title">
              <img :src="festivales[$route.path].img"></img>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 class="text-xs-center" mt-2 v-if="festivales[$route.path] && festivales[$route.path].title && festivales[$route.path].title === 'Navidad'">
              <h2>Esta navidad aterrorízate con un 25% de descuento con el código PHNAVIDAD</h2>
              <img :class="{active}" class="navidad" src="/festivales/navidad.png" @click="active = false">
            </v-flex>
            <v-flex xs12 class="text-xs-center" mt-2 v-else-if="festivales[$route.path] && festivales[$route.path].title">
              <h2>El Festival de {{festivales[$route.path] && festivales[$route.path].title}} te invita a disfrutar de Microcanales con el siguiente código de descuento: {{festivales[$route.path].code}}</h2>
            </v-flex>
            <v-flex xs12 class="text-xs-center" mt-2>
              <h2 v-if="festivales[$route.path] && festivales[$route.path].title">Regístrate con tu e-mail y prepárate para el terror</h2>
              <h1 v-else>{{$t('enjoy_with_email')}}</h1>
            </v-flex>
            <v-flex xs12 class="text-xs-center" mt-2 @click="setFocus">
              <v-layout column>
                <v-flex>
                  <v-alert type="error" dismissible v-if="error" v-model="alert">
                    {{ $t(error) }}
                  </v-alert>
                </v-flex>
                <v-flex>
                  <v-text-field
                    name="email"
                    :label="$t('email')"
                    id="email"
                    type="email"
                    v-model="email"
                    autocomplete="email"
                    :rules="[rules.fieldRequired, rules.email]"
                    required></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    name="password"
                    :label="$t('password')"
                    id="password"
                    type="password"
                    v-model="password"
                    autofocus
                    autocomplete="current-password"
                    :rules="[rules.fieldRequired, rules.min6]"
                    required></v-text-field>
                </v-flex>

                <v-flex class="text-xs-center">
                  <v-checkbox
                    :rules="[rules.fieldRequired]"
                    v-model="privacy"
                    @change="setPrivacy($event)">
                    <template v-slot:label>
                      <div v-html="$t('accept_privacy')">
                      </div>
                    </template>
                  </v-checkbox>
                </v-flex>

                <v-flex class="text-xs-center">
                  <v-checkbox
                    :rules="[rules.fieldRequired]"
                    v-model="terms"
                    @change="setTerms($event)">
                    <template v-slot:label>
                      <div>
                        {{$t('accept_terms')}}
                      </div>
                    </template>
                  </v-checkbox>
                </v-flex>

                <v-flex mb-4>
                  <label
                    class="error-font"
                    v-if="(!privacy || !terms) && focused"
                    small
                    color="error"
                  >{{$t('accept_terms_privacy')}}</label>
                </v-flex>
                
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="!valid || isLoading"
                  :loading="isLoading">{{title}}</v-btn>

                <v-flex xs12 class="text-xs-center" mt-5>
                  <v-btn flat to="/signin">{{$t('no_account')}}</v-btn>
                </v-flex>

              </v-layout>
            </v-flex>
          <!-- </v-layout> -->
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import { recurringPayment, fun } from '@/config'
import { mapActions, mapMutations } from 'vuex'
import { auth } from '@/config'
import google from '@/assets/google.svg'
import facebook from '@/assets/facebook.svg'
import email from '@/assets/email.svg'
import rules from '@/utils/rules'

const getCoupon = fun.httpsCallable('getCoupon')
export default {
  data () {
    return {
      valid: true,
      recurringPayment,
      active: true,
      signup: false,
      email: '',
      password: '',
      alert: false,
      isLoading: false,
      privacy: null,
      terms: null,
      focused: null,
      google,
      facebook,
      rules,
      social: true,
      couponValid: false,
      couponId: '',
      discount: null,
      discountValid: false,
      discountId: '',
      festivales: {
        '/navidad': {
          title: 'Navidad',
          code: 'PHNAVIDAD',
          class: 'navidad'
        },
        '/sitges': {
          title: 'Sitges',
          img: '/festivales/sitges.png',
          code: 'PHSITGES19',
          class: 'sitges'
        },
        '/molins': {
          title: 'Molins',
          img: '/festivales/molins.png',
          code: 'PHMOLINS19',
          class: 'molins'
        },
        '/nocturna': {
          title: 'Nocturna',
          img: '/festivales/nocturna.png',
          code: 'PHNOCTURNA19',
          class: 'nocturna'
        },
        '/Navidad': {
          title: 'Navidad',
          img: '/festivales/sitges.png',
          code: 'PHNAVIDAD',
          class: 'navidad'
        },
        '/Sitges': {
          title: 'Sitges',
          img: '/festivales/sitges.png',
          code: 'PHSITGES19',
          class: 'sitges'
        },
        '/Molins': {
          title: 'Molins',
          img: '/festivales/molins.png',
          code: 'PHMOLINS19',
          class: 'molins'
        },
        '/Nocturna': {
          title: 'Nocturna',
          img: '/festivales/nocturna.png',
          code: 'PHNOCTURNA19',
          class: 'nocturna'
        },
        '/signin': {},
        '/signup': {},
        '/samsung': {}
      }
    }
  },
  methods: {
    ...mapActions(['userSignIn', 'userSignInProvider', 'userSignUp', 'updateUserPrivacy', 'setError']),
    ...mapMutations(['setEmail', 'setSignup']),
    async userSignInCall (payload) {
      this.isLoading = true
      const res = await auth.fetchSignInMethodsForEmail(payload.email)
      this.signup = !(res.length && !!res.find(i => i === 'password'))

      if (this.signup) {
        const ok = await this.userSignUp({...payload, email: this.email})
        if (ok) {
          FB.AppEvents.logEvent('Register')
          this.$router.replace({ name: 'Home' })
        } else {
          this.$store.commit('setError', 'Error de credenciales')
        }
      } else {
        this.$store.commit('setError', 'El usuario ya está registrado')
      }
      this.isLoading = false
    },
    recoverPassword() {
      this.$router.push({ name: 'RecoverPassword'})
    },
    userSignInProviderCall(provider) {
      this.isLoading = true
      this.userSignInProvider(provider)
        .catch(() => {
          this.isLoading = false
        })
    },
    setPrivacy($event) {
      localStorage.setItem('privacy', $event ? Date.now() : 0)
    },
    setTerms($event) {
      localStorage.setItem('terms', $event ? Date.now() : 0)
    },
    setFocus () {
      this.focused = true
    },
    // async getDiscount() {
    //   try {
    //     // const res = await getCoupon({coupon_id: this.discountId})
    //     this.discountValid = true
    //     this.discount = res.data
    //   } catch (error) {
    //     this.discount = null
    //     this.discountValid = false
    //   }
    // },
    setDiscountId($event) {
      localStorage.setItem('discountId', $event)
      this.discountId = $event
    }
  },
  created() {
    localStorage.setItem('discountId', '')
    // this.email = this.$store.getters.email
    // this.setDiscountId('VALENTIN2020')
    // this.getDiscount()
    this.setPrivacy(false)
    this.setTerms(false)
  },
  computed: {
    title () {
      return !this.signup ? this.$t('navMenu.signup') : this.$t('navMenu.signIn')
    },
    error () {
      return this.$store.state.error
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.isLoading = false
        this.alert = true
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    },
    async '$route' (to, from, other) {
      if (this.$route.path === '/signin') {
        this.social = true
      } else {
        this.social = false
      }
    }
  },
  filters: {
    fixed2: function (value) {
      if (!value) return ''
      return Number(value).toFixed(2)
    },
    getDiscount: function (value) {
      if (!value) return ''
      return (19.99 - 19.99 * Number(value) / 100).toFixed(2)
    }
  },
  activated () {
    this.email = this.$store.getters.email
    this.$store.commit('setError', null)
    if (this.$route.query.source) {
      localStorage.setItem('source', this.$route.query.source)
    }
    if (this.$route.query.from === 'landing') {
      window.gtag('event', 'conversion', {'send_to': 'AW-743809320/QFNRCPPg5Z0BEKjC1uIC'})
    } else {
      window.gtag('event', 'conversion', {'send_to': 'AW-743809320/IEyXCJLl5Z0BEKjC1uIC'})
    }

    if (this.$route.path === '/signin') {
      this.social = true
    } else {
      window.adperf_conversion(284);
      this.social = false
    }
  }
}
</script>
<style scoped>
  .navidad:not(.active) {
    opacity: 0;
    z-index: 0;
  }
  .fetivales-logo.navidad {
    display: none;
  }
  .navidad {
    transition: opacity 1s;
    opacity: 1;
    position: relative;
    width: 100%;
    top: 0;
    left: 0;
    padding: 10px;
    /*z-index: 9999;*/
    object-fit: cover;
    object-position: right 15%;
    max-height: 700px;
  }
  .error-font {
    color: red;
    font-size: 13px;
  }
  .ph-label {
    color: rgba(0,0,0,0.54);
    font-size: 16px;
  }
  .google img {
    width: 20px;
  }
  .facebook img {
    width: 22px;
  }
  .email img {
    width: 22px;
    filter: brightness(0) invert(1);
  }
  .google img, .facebook img, .email img {
    margin: 0 10px;
  }
  .theme--light.v-icon {
    color: white;
  }

</style>
<style>

  .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: #f2613f!important;
  }

  .theme--light.v-label {
    color: white;
  }
  .v-input--checkbox .theme--light.v-icon {
    color: white;
  }

  .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: white;
  }


  .theme--light.v-btn {
    color: white;
  }

  .theme--light.application {
    background: black;
    color: white;
  }

  @media only screen and (max-width: 370px) {
    .molins img {
      width: 100%
    }
  }
  @media only screen and (max-width: 530px) {
    .sitges img {
      width: 100%
    }
  }
  .v-content__wrap {
    overflow: scroll;
  }
</style>
